const price = 204000;
const currentRate = '4.0';
const url = '/';

// ---------------------------------------------------------

export default {
  props: {
    currentRate: currentRate,
    price: price,
    url: url
  }
};
